import styles from '../TravelExpensesOverlayController.module.scss';

import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@work4all/components/lib/dataDisplay/card';

import { useUser } from '@work4all/data';
import { useUsersContext } from '@work4all/data/lib/hooks/users/users-context';

import { CountryPickerField } from '../../../../../../components/entity-picker/CountryPickerField';
import { UserPickerField } from '../../../../../../components/entity-picker/UserPickerField';
import { useSupplier } from '../../../../../files/detail/components/queries/use-supplier';
import { ControllerPlus } from '../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../form-plus/use-form-context-plus';
import { DateTimeInputPicker, LabeledInput } from '../../../../locked-inputs';
import { Collapse, ControlWrapper } from '../../../components';
import { useMaskContext } from '../../../hooks/mask-context';
import { TravelExpensesFormValue } from '../type';

export const GeneralInfo = () => {
  const { t } = useTranslation();

  const form = useFormContextPlus<TravelExpensesFormValue>();
  const { register, control } = form;

  const user = useUser();
  const mask = useMaskContext();

  const { isSupplierValid } = useSupplier(user?.supplierCode?.toString());

  const { users } = useUsersContext();

  return (
    <Collapse title={t('MASK.GENERAL')} defaultOpen>
      <Card>
        <Grid>
          <ControlWrapper>
            {mask.isCreateMode && (!user.supplierCode || !isSupplierValid) && (
              <Typography color="error">{t('ERROR.NO_SUPPLIER')}</Typography>
            )}
          </ControlWrapper>
          <ControlWrapper>
            <LabeledInput
              label={t('COMMON.TITLE')}
              {...register('travelPurpose')}
              required
            />
          </ControlWrapper>

          <ControlWrapper className={styles.assignmentControls}>
            <ControlWrapper paddingBottom={false}>
              <DateTimeInputPicker
                {...register('date')}
                dateLabel={t('INPUTS.BOOKING_DATE')}
                withTime={false}
                clearable={false}
                required
              />
              <LabeledInput
                label={t('INPUTS.NUMBER')}
                {...register('businessTripContractNumber')}
                type="number"
              />
            </ControlWrapper>

            <ControlWrapper paddingBottom={false}>
              <ControllerPlus
                control={control}
                name="businessPartner"
                render={({ field }) => {
                  const { onChange, value, ...others } = field;
                  const user = users.find(
                    (user) => user.supplierId === value?.id
                  );
                  return (
                    <UserPickerField
                      {...others}
                      data={{ id: null, displayName: null, supplierId: null }}
                      prefilter={[{ supplierId: { $ne: 0 } }]}
                      multiple={false}
                      clearable={false}
                      label={t('FIELDS.traveler')}
                      value={user}
                      onChange={(user) => {
                        const supplierId = user?.supplierId;
                        if (!supplierId) {
                          onChange(null);
                          return;
                        }
                        onChange({ id: supplierId });
                      }}
                    />
                  );
                }}
              />
            </ControlWrapper>

            <ControlWrapper paddingBottom={false}>
              <ControllerPlus
                name="country"
                control={form.control}
                render={({ field }) => {
                  return (
                    <CountryPickerField
                      label={t('INPUTS.COUNTRY')}
                      {...field}
                      required
                      value={field.value}
                      onChange={(result) => {
                        field.onChange(result);
                        form.setValue('countryId', result?.id || null);
                      }}
                    />
                  );
                }}
              />

              <LabeledInput label={t('COMMON.CITY')} {...register('city')} />
            </ControlWrapper>
          </ControlWrapper>
        </Grid>
      </Card>
    </Collapse>
  );
};
